import { Component, OnInit } from '@angular/core';
import { PRIVACYNOTICEURL } from 'src/shared/constants';

/**
 * Ruta vieja /avisos-privacidad. El aviso ya no vive dentro del sistema:
 * quien entre aquí se manda directo a la página oficial en aliwell.mx.
 */
@Component({
  selector: 'app-privacy-notices',
  templateUrl: './privacy-notices.component.html',
  styleUrls: ['./privacy-notices.component.css']
})
export class PrivacyNoticesComponent implements OnInit
{
  public readonly privacyNoticeUrl: string = PRIVACYNOTICEURL;

  ngOnInit(): void
  {
    // replace() para que el botón "atrás" no regrese a esta página y vuelva a redirigir
    window.location.replace(this.privacyNoticeUrl);
  }
}
